export default __webpack_public_path__ + "static/media/golden visa process time fees.8f0c023c.jpg";